import React, { Fragment, useState } from 'react';
import T from 'prop-types';
import { isEmpty } from 'lodash-es';

import skeletons from './Skeletons';
import SimpleCard from '../../../Card/SimpleCard';
import ErrorStateWithReload from '../../../ErrorStateWithReload';
import BaseChart from '../../../../pages/company-page-v2/components/CompanyPerformance/Drivers/BaseView/BaseChart';

const chartOptions = [
  { baseKey: 'downloadsChart' },
  { baseKey: 'metricsChart' },
];

const chartStyleOverride = {
  axisLabelsFontSize: 11,
  chartHeight: 210,
};

const DriversQV = ({
  data,
  settings,
}) => {
  const [chartSectionsConfig, setChartSectionsConfig] = useState({
    downloadsChart: { metric: 'downloads' },
    metricsChart: { metric: 'mau' },
  });

  if (settings.error) {
    return <ErrorStateWithReload />;
  }

  return (
    <SimpleCard
      className="drivers-qv"
      headerLeft={<h4 className="h4">Drivers</h4>}
      headerRight="Worldwide"
    >
      <div className="drivers-base-view">
        {chartOptions.map(item => (
          <Fragment key={item.baseKey}>
            {settings.pending && skeletons.drivers.baseChart}
            {!settings.pending && !isEmpty(data) && (
              <BaseChart
                sectionKey={item.baseKey}
                data={data}
                chartSectionConfig={{
                  metric: chartSectionsConfig[item.baseKey].metric,
                }}
                overPeriod="year_over_year"
                showActivePoint
                showFooter={false}
                chartStyleOverride={chartStyleOverride}
                onMetricChange={metric => setChartSectionsConfig(prev => ({
                  ...prev,
                  [item.baseKey]: { metric },
                }))}
              />
            )}
          </Fragment>
        ))}
      </div>
    </SimpleCard>
  );
};

DriversQV.propTypes = {
  data: T.object,
  settings: T.object.isRequired,
};

export default DriversQV;
